const initialState = {
    refreshPageValue:[],
};
export const actionTypes = {
    REFRESH_PAGE:"REFRESH_PAGE",
};

export const actions = {
    refresh_page: function (data) {
        return {
            type: actionTypes.REFRESH_PAGE,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.REFRESH_PAGE:{
            return {...state,refreshPageValue:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/refreshPageReducer.js